import React, { useEffect, useState } from "react";
import { getAxiosHeaders } from "../../../utils/Utils";
import { Icon, Button } from "../../../components/Component";
import { baseURLs } from "../../../utils/Constants";
import {
  Alert,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Input, Select, Checkbox, Form, InputNumber } from "antd";
import { AlertModal, SuccessModal, LoadingModal } from "../AlertModals";
import { LinkItUrl } from "react-linkify-it";
import ProcessingIcon from "../../../images/processing.png";
import DeliveredIcon from "../../../images/delivered.png";
const { Option } = Select;
const { TextArea } = Input;

const ExpenseFulfillmentInfo = ({ expenseInfo, setExpenseInfo, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [errorMessage, setErrorMessage] = useState("");
  const [activeModal, setActiveModal] = useState(null);

  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const handleFormSubmit = (_formData) => {
    setLoading(true);
    setErrorMessage("");

    axios
      .put(
        baseURLs.API_URL + `/expenses/fulfillment/${expenseInfo.expense_id}`,
        {
          business_id: expenseInfo.business_id,
          fulfillment_status: _formData.fulfillment_status,
        },
        getAxiosHeaders()
      )
      .then((response) => {
        let responseInfo = response.data;
        let _expenseInfo = expenseInfo;

        _expenseInfo.fulfillment_status = responseInfo.data.fulfillment_status;
        setExpenseInfo({ ..._expenseInfo });

        toggleModal("successModal");
        setLoading(false);
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          if (errorResponse.hasOwnProperty("errors")) {
            form.setFields([
              {
                name: "fulfillment_status",
                errors: errorResponse.errors.hasOwnProperty(
                  "fulfillment_status"
                )
                  ? [errorResponse.errors.fulfillment_status]
                  : [],
              },
            ]);
          }

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setErrorMessage(errorMessage);
          setLoading(false);
        } catch (e) {
          setErrorMessage("Error: Could not connect to server");
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getFulfillmentStatus = (status) => {
    switch (status) {
      case "pending_delivery":
        return "Pending Delivery";

      case "delivered":
        return "Delivered";

      default:
        return "Pending Delivery";
    }
  };

  return (
    <div className="fm-footer" style={{ backgroundColor: "#1c2b46" }}>
      <div className="nk-help">
        <div className="nk-help-img w-100px mr-0">
          {expenseInfo.fulfillment_status === "pending_delivery" && (
            <img
              src={ProcessingIcon}
              width="80px"
              alt={getFulfillmentStatus(expenseInfo.fulfillment_status)}
            />
          )}

          {expenseInfo.fulfillment_status === "delivered" && (
            <img
              src={DeliveredIcon}
              width="80px"
              alt={getFulfillmentStatus(expenseInfo.fulfillment_status)}
            />
          )}
        </div>
        <div className="nk-help-text">
          <span className="sub-title text-white">Fulfillment Status:</span>
          <h5 className="title text-white">
            {getFulfillmentStatus(expenseInfo.fulfillment_status)}
          </h5>
          <p className="mb-0">
            <small className="text-white">
              Updated By: {expenseInfo.updated_by}
            </small>
          </p>
        </div>
        {expenseInfo.fulfillment_status !== "delivered" && (
          <div className="dark-mode nk-help-action text-md-center">
            <button
              onClick={() => toggleModal("fulfillmentModal")}
              className="btn btn-md btn-primary"
            >
              Update Status
            </button>
          </div>
        )}
      </div>

      {/* fulfillment modal */}
      {activeModal === "fulfillmentModal" && (
        <Modal backdrop="static" isOpen={true} id="fulfillment-modal">
          <ModalHeader
            toggle={() => toggleModal("fulfillmentModal")}
            close={
              <button
                className="close"
                onClick={() => toggleModal("fulfillmentModal")}
              >
                <Icon name="cross" />
              </button>
            }
          >
            Update Fulfillment Status
          </ModalHeader>
          <Form
            name="update-fulfillment"
            form={form}
            className="is-alter"
            onFinish={handleFormSubmit}
            initialValues={{
              fulfillment_status: expenseInfo.fulfillment_status,
            }}
            onFinishFailed={onFinishFailed}
          >
            <ModalBody>
              {errorMessage && (
                <div className="mb-3">
                  <Alert color="danger" className="alert-icon">
                    {" "}
                    <Icon name="alert-circle" /> {errorMessage}{" "}
                  </Alert>
                </div>
              )}

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <Form.Item>
                      <div className="form-label-group">
                        <label className="form-label">
                          Fulfillment Status{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="form-control-wrap">
                        <Form.Item
                          name={"fulfillment_status"}
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Fulfillment status is required",
                            },
                          ]}
                        >
                          <Select
                            required
                            size="large"
                            name="country"
                            placeholder="Select fulfillment status"
                            style={{ width: "100%" }}
                            options={[
                              {
                                key: "pending_delivery",
                                label: "Pending Delivery",
                                value: "pending_delivery",
                              },
                              {
                                key: "delivered",
                                label: "Delivered",
                                value: "delivered",
                              },
                            ]}
                            showSearch
                          />
                        </Form.Item>
                      </div>
                    </Form.Item>
                  </div>
                </div>
                {/* <div className="col-md-12">
                  <div className="form-group">
                    <Form.Item>
                      <div className="form-label-group">
                        <label className="form-label">
                          Note <span className="text-muted">(optional)</span>
                        </label>
                      </div>
                      <div className="form-control-wrap">
                        <Form.Item
                          name={"order_note"}
                          noStyle
                          rules={[{ required: false }]}
                        >
                          <TextArea rows={4} placeholder="Order Note" />
                        </Form.Item>
                      </div>
                    </Form.Item>
                  </div>
                </div> */}
                <div className="col-md-12"></div>
              </div>
            </ModalBody>
            <ModalFooter className="bg-lighter justify-content-center">
              <div className="text-start">
                <Button
                  className="m-1"
                  disabled={loading}
                  type="submit"
                  color="primary"
                  size="md"
                >
                  {loading ? (
                    <Spinner size="sm" color="light" />
                  ) : (
                    "Update Status"
                  )}
                </Button>
                <Button
                  className="m-1"
                  disabled={loading}
                  type="button"
                  onClick={() => toggleModal("Modal")}
                  color="light"
                  size="md"
                >
                  Close
                </Button>
              </div>
            </ModalFooter>
          </Form>
        </Modal>
      )}

      {/* success modal */}
      {activeModal === "successModal" && (
        <SuccessModal
          showModal={true}
          toggleModal={() => toggleModal("successModal")}
          headerText={"Fulfillment Updated"}
          descriptionText={"Fulfillment status has been updated successfully."}
        />
      )}
    </div>
  );
};

export default ExpenseFulfillmentInfo;
